import apiFetch from '../apiFetch'

export default function (documentId, organizedUnitId, infoIncome, token, lastAccessDate) {
  const queryParams = organizedUnitId ? `?organizedUnitId=${organizedUnitId}` : '?organizedUnitId=null'
  return apiFetch({ endPoint: `document/${documentId}/Fleets${queryParams}`, method: 'PUT', body: infoIncome, token: token, lastAccessDate })
}
